export default "__VITE_ASSET__y3e$sDeV__"